import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

// ===== USER (knowledge-base) =====
const Article = lazy(() => import("@/pages/KnowledgeBase/Nested/Article/Article"));
const Category = lazy(() => import("@/pages/KnowledgeBase/Category"));
const SearchResults = lazy(() => import("@/pages/KnowledgeBase/SearchResults"));
const TestingKnowledgeBaseMaterial = lazy(
    () => import("@/pages/Testing/KnowledgeBase/Material/TestingKnowledgeBaseMaterialPage"),
);
const TestingQuestion = lazy(
    () => import("@/pages/Testing/Question/TestingQuestionPage"),
);
const TestingTest = lazy(
    () => import("@/pages/Testing/Test/TestingTestPage"),
);

// ===== ADMIN (control-panel/knowledge-base) =====
const InCPCreateArticle = lazy(() => import('@/pages/ControlPanel/Nested/KnowledgeBase/Nested/CreateArticle'));
const EditArticle = lazy(() => import("@/pages/ControlPanel/Nested/KnowledgeBase/Nested/EditArticle"));
const InCPSearch = lazy(() => import("@/pages/ControlPanel/Nested/KnowledgeBase/Nested/Search"));

const urlsConfig = new UrlsConfig();

export function knowledgeBaseRoutes() {
    return (
      <>
          {/* ===== USER: /knowledge-base/... ===== */}
          <Route path={`${urlsConfig.knowledgeBase.to}/article/:articleId`} element={<Article/>}/>
          <Route path={urlsConfig.knowledgeBaseSearchResults.to} element={<SearchResults/>}/>
          <Route path={`${urlsConfig.knowledgeBase.to}/:categoryId/*`} element={<Category/>}/>
          <Route
              path={`${urlsConfig.testingKnowledgeBase.to}/material/:alias`}
              element={<TestingKnowledgeBaseMaterial/>}
          />
          <Route
              path={`${urlsConfig.testing.to}/question/:alias`}
              element={<TestingQuestion/>}
          />
          <Route
              path={`${urlsConfig.testing.to}/test/:alias/attempt/:resultId`}
              element={<TestingTest/>}
          />
          <Route
              path={`${urlsConfig.testing.to}/test/:alias`}
              element={<TestingTest/>}
          />

          {/* ===== ADMIN: /control-panel/knowledge-base/... ===== */}
          <Route path={urlsConfig.inControlPanelKnowledgeBaseCreateArticle.to} element={<InCPCreateArticle/>}/>
          <Route path={`${urlsConfig.inControlPanelKnowledgeBaseEditArticle.to}/:articleId`} element={<EditArticle/>}/>
          <Route path={urlsConfig.inControlPanelKnowledgeBaseSearch.to} element={<InCPSearch/>}/>
      </>
    );
}
